module.exports = __webpack_public_path__ + "img/insurita-testimonials-left.0622dc08.svg";